import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { countdownCardStyles } from './countdownCardStyles';
import { useTheme } from '@mui/material/styles';
import { ASSETS_PATH } from '../../services/endpoints';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';

export interface ICountDownCardImage {
  index?: number;
}
export const CountDownCardImage = ({ index }: ICountDownCardImage) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const imagePath = `${ASSETS_PATH}/img/brickken_shape_png.png`;
  const classes = countdownCardStyles(theme, imagePath);
  const gifUrl = `${ASSETS_PATH}/img/gif_party_time.gif`;
  const isDownSm = useMediaQuery(theme.breakpoints.down('md'));
  const variantTitle = isDownSm ? 'h6' : 'h4';
  const variantSubitle = isDownSm ? 'h5' : 'h3';

  return (
    <Grid item justifyContent='center' sx={classes.container}>
      <Box sx={classes.textMaskImage}>
        <Typography variant={variantTitle} sx={classes.countdownCompletedTitle}>
          {t(`vesting.card_data.round.title`, { round: index + 1 })}
        </Typography>
        <Typography
          variant={variantSubitle}
          sx={classes.countdownCompletedSubtitle}
        >
          {t('vesting.countdown_card_image.title_party_time.text')}
        </Typography>
      </Box>
      <Box sx={classes.gifMaskBox}>
        <img
          src={gifUrl}
          alt='Open vault with money'
          width='100%'
          height='100%'
          style={classes.gif}
        />
      </Box>
    </Grid>
  );
};
